import CountUp from '@/components/ui/CountUp';

const COLS = { 2: 'lg:grid-cols-2', 3: 'lg:grid-cols-3', 4: 'lg:grid-cols-4' };

export default function StatsBand({ stats = [], tone = 'flame' }) {
  const flame = tone === 'flame';
  return (
    <section className={flame ? 'bg-flame-x text-white' : 'bg-white text-ink-950'} aria-label="Key numbers">
      <div className={`site-container grid grid-cols-2 gap-px ${stats.length === 3 ? 'sm:grid-cols-3' : ''} py-2 ${COLS[Math.min(stats.length, 4)] || ''}`}>
        {stats.map((s) => (
          <div key={s.label} className="px-4 py-8 text-center">
            <CountUp value={s.value} className="block font-display text-5xl font-extrabold leading-none sm:text-6xl" />
            <p className={`mt-2 text-sm font-medium uppercase tracking-[0.14em] ${flame ? 'text-white/85' : 'text-ink-500'}`}>{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
